module.exports = __webpack_public_path__ + "img/sao.9cf88cba.png";